import {type Zoom} from './uPlotSetZoom';

// handle click on the plot to clear the zoom https://github.com/leeoniya/uPlot/blob/master/demos/zoom-fetch.html#L35-L43
export function handleInit(onZoom?: (zoom: Zoom) => void) {
  return (u: uPlot) => {
    u.over.addEventListener('click', () => {
      u.setSelect({left: 0, top: 0, width: 0, height: 0}, false);
      onZoom?.({
        xAxisMin: undefined,
        xAxisMax: undefined,
        yAxisMin: undefined,
        yAxisMax: undefined,
      });
    });
  };
}
